import { CONSTANT } from './constants';
import { readLocal, saveLocal } from './localStorageHelper';

export const saveNavigation = (s) => saveLocal(`hpr-navigation-${CONSTANT.version}`, s);
export const getNavigation = () => readLocal(`hpr-navigation-${CONSTANT.version}`, null);
